import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import windowSizeMixin from '@/mixins/windowSizeMixin'; //混入-浏览器窗口监听
import eventBus from '@/utils/eventBus'; //消息组件
import 'swiper/dist/css/swiper.css';
import { Popup, Button, Icon, Tab, Tabs, ActionSheet } from "vant";
import store from '@/store'; //vuex
Vue.prototype.$ArticleUrl = 'https://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx';
Vue.use(Popup);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(ActionSheet);
Vue.prototype.$eventBus = eventBus;
// import store from './store'
Vue.use(ElementUI);
Vue.mixin(windowSizeMixin);
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')